import { render, staticRenderFns } from "./myWallet.vue?vue&type=template&id=c2b82246&"
import script from "./myWallet.vue?vue&type=script&lang=js&"
export * from "./myWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports